// COPIA da TMA#718 di CriGio @ 4638c540: src/components/burraco/TavoloVerticale.tsx:405-407 (il tasto «Ordina»; anche TavoloStage.tsx:344-350)
// Cambi: componente a se' (nel Burraco e' un pezzo di JSX in due file), il testo arriva dal chiamante (e' del namespace del suo gioco). I-807 (tma-orc-9): nel CP il tasto e' in rilievo come la rotella delle
// impostazioni (`tav-tasto-rilievo`, `tono="pieno"`), non col solo contorno d'oro `tav-contorno` (ex `bur-contorno`): il Burraco ha le sue copie e non cambia.
import { ArrowDown01, Spade } from 'lucide-react';

import { Button } from '@/components/common/Button';
import type { Ordine } from '@/lib/tavolo/ordinaMano';

/**
 * «Ordina»: un'azione sulla mano. Stessa famiglia di colore e stesso peso visivo della rotella delle impostazioni (cupola di vetro verde con filo d'oro, `tav-tasto-rilievo`): le
 * distingue l'icona. L'icona dice l'ordine di ADESSO (`Spade` = per seme, `ArrowDown01` = per valore),
 * il nome accessibile e il `title` lo stesso, come nel Burraco. Un tocco alterna l'ordine; il tasto non sa niente di carte.
 */
export function TastoOrdina({ ordine, etichetta, onClick }: { ordine: Ordine; etichetta: string; onClick: () => void }) {
  return (
    <Button variant="icona" tono="pieno" size={40} data-azione="ordina" data-ordine={ordine} className="tav-tasto-rilievo" aria-label={etichetta} title={etichetta} onClick={onClick}>
      {ordine === 'seme' ? <Spade aria-hidden size={22} /> : <ArrowDown01 aria-hidden size={22} />}
    </Button>
  );
}
